module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-right-item attention"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDataLoading),
      expression: "!isDataLoading"
    }],
    staticClass: "bk-form"
  }, [_c('div', {
    staticClass: "upload-form"
  }, [_c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("收费模式：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, _vm._l((_vm.tradeMode.model), function(item, index) {
    return _c('label', {
      staticClass: "bk-form-radio"
    }, [_c('input', {
      staticClass: "bk-radio-text",
      attrs: {
        "type": "radio",
        "name": "radio1",
        "checked": "checked"
      },
      domProps: {
        "value": item.type
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "bk-radio-text"
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)]), _vm._v(" "), _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('bk-selector', {
    staticStyle: {
      "width": "310px",
      "display": "inline-block"
    },
    attrs: {
      "list": _vm.tradeMode.openSource.list,
      "selected": _vm.tradeMode.openSource.selected
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.tradeMode.openSource, "selected", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('bk-selector', {
    staticStyle: {
      "width": "310px",
      "display": "inline-block"
    },
    attrs: {
      "list": _vm.tradeMode.support.list,
      "selected": _vm.tradeMode.support.selected
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.tradeMode.support, "selected", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tradeMode.freeUrl),
      expression: "tradeMode.freeUrl"
    }],
    staticClass: "bk-form-input",
    class: {
      'bk-input-checked': _vm.check.test_url.isShow
    },
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "type": "url",
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.tradeMode.freeUrl)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tradeMode, "freeUrl", $event.target.value)
      }, _vm.checkValidate]
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "upload-action"
  }, [_c('a', {
    class: ['bk-button', 'bk-primary', {
      'is-loading': _vm.saveFlag === false
    }],
    attrs: {
      "id": "submit",
      "title": "提交"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v("提交")])]), _vm._v(" "), _c('a', {
    staticClass: "bk-button bk-return",
    attrs: {
      "title": "返回"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('span', [_vm._v("返回")])])])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bk-form-item",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 收费价格：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('span', {
    staticClass: "bk-form-span",
    staticStyle: {
      "color": "#ff6600"
    }
  }, [_vm._v("免费")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }), _vm._v(" 开源协议：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }), _vm._v(" 服务支持：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }), _vm._v(" 开源链接：")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-339101a5!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/works/trading_mode.vue
// module id = uaQ9
// module chunks = 16